import { getAccessToken, getIsAuthenticated, getRefreshToken } from "../../utils/user";

/* eslint-disable @typescript-eslint/naming-convention */
export type AuthState = {
  authFlow: AUTH_FLOW;
  isAuthenticated: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthLoading: boolean;
  mfaSetupData: IMfaSetupData | null;
  mfaCheckData: IMfaCheckData | null;
  email: string | null;
  password_digest: string | null;
};

export interface IMfaCheckData {
  session: string;
}

export interface IMfaSetupData extends IMfaCheckData {
  code: string;
  qrImage: string;
}

export const enum AUTH_FLOW {
  BASIC = "BASIC",
  CHECK_EMAIL = "CHECK_EMAIL",
  FIRST_SIGN_IN = "FIRST_SIGN_IN",
  MFA_CHECK = "MFA_CHECK",
  MFA_SETUP = "MFA_SETUP",
  MFA_SETUP_COMPLETED = "MFA_SETUP_COMPLETED",
  UNCONFIRMED = "UNCONFIRMED",
  WITH_INVITATION_CODE = "WITH_INVITATION_CODE",
}

export const defaultAuthState: AuthState = {
  authFlow: AUTH_FLOW.CHECK_EMAIL,
  isAuthenticated: getIsAuthenticated(),
  accessToken: getAccessToken(),
  refreshToken: getRefreshToken(),
  isAuthLoading: false,
  mfaCheckData: null,
  mfaSetupData: null,
  email: null,
  password_digest: null,
};
